import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  .sys-icon {
    height: 36px;
    .loading-ic {
      margin-right: 8px;
    } 
  }
  
  span {
    font-size: var(--font-size-lg);
    font-weight: 600;
    color: #101828;
    margin-bottom: 0px;
    line-height: 20px;
  }

  .anticon-loading {
    color: var(--mmt-primary-70) !important;
  }

  .mb-1 {
    margin-bottom: 8px;
  }

  .mb-2 {
    margin-bottom: 28px;
  }

  .mb-3 {
    margin-bottom: var(--size);
  }

  .perc-cont {
    width: 38px;
    text-align: center;
  }

  .details-header {
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 48px;
    gap: var(--size);
    min-height: 28px;

    .tag {
      border: 1px solid var(--color-primary-70);
      background: var(--color-primary-20);
      border-radius: 6px;
      padding: 6px 9px;
  
      span {
        font-size: 14px;
        font-weight: 500;
        color: #344054;
        margin-bottom: 0px;
        line-height: 14px;
      }

      &.gold {
        border-color: #F7DE3A;
        background: rgba(247, 222, 58, 0.05);
      }

      &.empty {
        border-color: #98A2B3;
        background: #98A2B30D;
      }
    }
  }

  .details-body {
    gap: 48px;

    .icon {
      padding: 4px;
      border-radius: 100%;

      .layer {
        padding: 4px;
        border-radius: 100%;
      }

      &.active {
        background: #EFF8FF;

        .layer {
          background: #D1E9FF;
        }
      }
    }
  }

  .systems {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0 40px;
    overflow: hidden;

    span {
      color: #344054;
      font-size: 14px;
      font-weight: 500;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
`;
